<script>
import baseMixin from '@/mixins/baseMixin'
import CandidateImage from '@/components/candidate/candidate-image.vue'

export default {
  name: 'BookingCardSkeletonLoader',
  components: {
    CandidateImage,
  },
  mixins: [baseMixin],
}
</script>

<template>
  <v-card class="mb-5 booking-card custom-elevation rounded-xl" elevation="0">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" lg="4" class="d-flex">
          <div>
            <v-lazy>
              <CandidateImage
                :id="-1"
                first-name="skeleton"
                last-name="loader"
                rounded
                size="xxxl"
              />
            </v-lazy>
          </div>
          <div>
            <v-skeleton-loader
              class="mb-2"
              type="heading"
              width="350"
            ></v-skeleton-loader>

            <v-skeleton-loader type="sentences" width="250"></v-skeleton-loader>
            <v-skeleton-loader type="sentences" width="350"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <div>
            <v-skeleton-loader type="sentences" width="200"></v-skeleton-loader>
          </div>
        </v-col>
      </v-row>

      <div class="clearfix"> </div>
    </v-card-text>
  </v-card>
</template>
